import { render, staticRenderFns } from "./PersonABMComponent.vue?vue&type=template&id=2708be7c&scoped=true"
import script from "./PersonABMComponent.js?vue&type=script&lang=js&external"
export * from "./PersonABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./PersonABMComponent.vue?vue&type=style&index=0&id=2708be7c&prod&scoped=true&lang=scss"
import style1 from "./PersonABMComponent.vue?vue&type=style&index=1&id=2708be7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708be7c",
  null
  
)

export default component.exports